import type React from "react";
import type { ChildrenProps } from "../types";
import { cn } from "../utils";
import { useDataTableContext } from "./data-table/context";
import { DataTableBlankSlate } from "./data-table/data-table-blank-slate";
import { DataTableLoading } from "./data-table/data-table-loading";

/** Props */
interface TableProps extends ChildrenProps {
	/** Must be a stable component reference — an inline arrow would remount the footer every render */
	Footer: React.ComponentType | null;
	ref?: React.Ref<HTMLDivElement>;
	isLoading: boolean;
}

export function Table({ children, Footer, ref, isLoading }: TableProps) {
	/** Context */
	const { table, columnSizes, isMonospaced, variant, tableBoxRef } = useDataTableContext();

	/** Render */
	return (
		<div
			className={cn(
				"data-table flex flex-col grow-0 gap-2 min-w-0 h-full min-h-0",
				variant === "sub-table" && "sub-data-table",
				isMonospaced && "table-mono",
			)}
		>
			<div
				className={cn("table-container overflow-auto")}
				ref={ref}
			>
				<div
					className="table-box"
					style={columnSizes}
					ref={tableBoxRef}
				>
					{children}
				</div>
				{isLoading && <DataTableLoading />}
				{!table.getRowModel().rows.length && !isLoading ? <DataTableBlankSlate /> : null}
			</div>
			{Footer && <Footer />}
		</div>
	);
}
